import { alereAxios } from '../utils/api';

export const login = (data) => alereAxios.post('auth/login-by-email', data);
export const logout = (data) => alereAxios.post('auth/logout', data);
